<template>
  <div
    class="flex flex-col justify-start items-center content-center w-full h-screen pt-64"
  >
    <div class="font-bold font-Foco text-30px md:text-70px text-qwray">
      {{ $t('not_found.header') }}
    </div>
    <div class="text-14px md:text-20px">{{ $t('not_found.text') }}</div>
    <div
      class="text-14px md:text-20px cursor-pointer mt-4 bg-qwellow px-10 py-1 rounded-full"
    >
      <a v-bind:href="'/' + locale">{{ $t('not_found.back_home') }}</a>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n';

export default {
  data() {
    return {
      locale: i18n.locale,
    };
  },
};
</script>
<style></style>
